import { render, staticRenderFns } from "./TableProjectScoreGroups.vue?vue&type=template&id=815a5942&"
import script from "./TableProjectScoreGroups.vue?vue&type=script&lang=js&"
export * from "./TableProjectScoreGroups.vue?vue&type=script&lang=js&"
import style0 from "./TableProjectScoreGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports